<template>
  <div class="sn-f-col-c-c sn-no-data">
    <div class="iconfont icon-zanwushuju"></div>
    <div class="explain">
      <template v-if="message">{{ message }}</template>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sn-no-data',
  props: {
    message: {
      type: [String, Boolean],
      default: '暂无数据'
    }
  }
};
</script>
<style lang="scss">
.sn-no-data {
  background-color: $transparent;
  margin-top: 40px;

  .iconfont {
    font-size: 60px;
    color: $text3;
  }

  .explain {
    @include fs(16);

    color: $text3;
    margin-top: 10px;
  }
}
</style>
